/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


 (function() {
  // Add custom code below this line
document.addEventListener('click', function(e){

const removeBtn = e.target.closest('[data-item-remove]');
if (!removeBtn) return;

// Stop theme AJAX cart behaviour
e.preventDefault();

// 👉 get tags from row
const row = removeBtn.closest('[data-cart-item]');
const tags = row ? row.getAttribute('data-tags') || '' : '';

// 🔥 ALERT TAGS
// alert('Tags: ' + tags);

const removeUrl = removeBtn.getAttribute('href');

fetch(removeUrl)
  .then(function() {
    return fetch('/cart.js'); // get updated cart
  })
  .then(function(res) {
    return res.json();
  })
  .then(function(cart) {

    // 🔥 ALERT CART COUNT
    // alert('Cart count: ' + cart.item_count);
    //REDIRECT
    if (cart.item_count === 0 && tags == 'airmethods') {
      window.location.href = 'https://swag.kotisdesign.com/collections/airmethods';

    } else if (cart.item_count === 0 && tags == 'rayban-meta') {
      window.location.href = 'https://swag.kotisdesign.com/collections/meta';

    } else {
      // keep your existing behavior
      window.location.reload();
    }

    // window.location.reload();

  })
  .catch(function(err) {
    console.error(err);
    window.location.reload();
  });

});




// ORIGINAL (function() {
//   // Add custom code below this line
// document.addEventListener('click', function(e){

//   const removeBtn = e.target.closest('[data-item-remove]');
//   if (!removeBtn) return;

//   // Stop theme AJAX cart behaviour
//   e.preventDefault();

//   const removeUrl = removeBtn.getAttribute('href');

//   fetch(removeUrl)
//     .then(() => {
//       window.location.reload();
//     });

// });




// ===============================
// SWAG → AUTO ACTIVATE KOTIS PICKS
// ===============================
// document.addEventListener("mouseover", function (e) {

// // const picksRow = document.querySelector(".kotis-picks-row");
// // if (picksRow) {
// //   picksRow.classList.add("force-active");
// // }

//   const swagTop = e.target.closest('[data-top-link]');
//   if (!swagTop) return;

//   if (!swagTop.textContent.trim().includes("Swag")) return;

//   setTimeout(function () {

//     const picksTab = document.getElementById("kotis_picks_menu");
//     const picksContent = document.getElementById("kotis_picks_content");

//     if (!picksTab || !picksContent) return;

//     document.querySelectorAll(".swag_menu").forEach(tab => {
//       tab.classList.remove("active");
//     });

//     document.querySelectorAll(".menu_item_flex").forEach(row => {
//       row.classList.remove("active");
//     });

//     document.querySelectorAll(
//       "#kotis_custom_content, #kotis_guides_content, #kotis_brands_content"
//     ).forEach(panel => {
//       panel.style.display = "none";
//     });

//     picksTab.classList.add("active");

//     // ✅ FIXED HERE
//     const picksRow = picksTab.querySelector(".menu_item_flex");
//     if (picksRow) {
//       picksRow.classList.add("active");
//     }

//     picksContent.style.display = "block";

//   }, 80);

// });


// ===============================
// SWAG OVERVIEW → KEEP PICKS ACTIVE
// ===============================
// document.addEventListener("mouseover", function (e) {

//   const overview = e.target.closest("#swag_overview_menu");
//   if (!overview) return;

//   const picksTab = document.getElementById("kotis_picks_menu");
//   const picksContent = document.getElementById("kotis_picks_content");

//   if (!picksTab || !picksContent) return;

//   document.querySelectorAll(".swag_menu").forEach(tab => {
//     tab.classList.remove("active");
//   });

//   document.querySelectorAll(".menu_item_flex").forEach(row => {
//     row.classList.remove("active");
//   });

//   picksTab.classList.add("active");

//   const picksRow = picksTab.querySelector(".menu_item_flex");
//   if (picksRow) {
//     picksRow.classList.add("active");
//   }

//   picksContent.style.display = "block";

// });



//START NEW
// Auto-activate Kotis Picks when Swag dropdown opens

// document.addEventListener("DOMContentLoaded", function () {

//   const swagParent = document.querySelector('[aria-controls="dropdown-04efb7e6ce1f31e014d2e8ba7c2cff8b"]');
//   const kotisPicksMenu = document.getElementById("kotis_picks_menu");
//   const kotisPicksContent = document.getElementById("kotis_picks_content");

//   const allMenus = document.querySelectorAll(".swag_menu");
//   const allContents = document.querySelectorAll(
//     "#kotis_catalog_content,#kotis_picks_content, #kotis_custom_content, #kotis_guides_content, #kotis_brands_content"
//   );

//   if (!swagParent) return;

//   // 🔥 When entering Swag dropdown
//   swagParent.addEventListener("mouseenter", function () {

//     setTimeout(function () {

//       allMenus.forEach(menu => menu.classList.remove("force-active"));
//       allContents.forEach(panel => panel.style.display = "none");

//       kotisPicksMenu.classList.add("force-active");
//       kotisPicksContent.style.display = "block";

//     }, 80);

//   });

//   // 🔥 When hovering ANY left menu item
//   allMenus.forEach(menu => {
//     menu.addEventListener("mouseenter", function () {
//       allMenus.forEach(m => m.classList.remove("force-active"));
//     });
//   });

//   // 🔥 When leaving entire dropdown
//   swagParent.addEventListener("mouseleave", function () {
//     allMenus.forEach(menu => menu.classList.remove("force-active"));
//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  const swagParent = document.querySelector(
    '[aria-controls="dropdown-04efb7e6ce1f31e014d2e8ba7c2cff8b"]'
  );

  const kotisCatalogMenu = document.getElementById("kotis_catalog_menu");
  const kotisCatalogContent = document.getElementById("kotis_catalog_content");

  const kotisPicksMenu = document.getElementById("kotis_picks_menu");
  const kotisPicksContent = document.getElementById("kotis_picks_content");

  const kotisCustomMenu = document.getElementById("kotis_custom_menu");
  const kotisCustomContent = document.getElementById("kotis_custom_content");

  const kotisGuidesMenu = document.getElementById("kotis_guides_menu");
  const kotisGuidesContent = document.getElementById("kotis_guides_content");

  const kotisBrandsMenu = document.getElementById("kotis_brands_menu");
  const kotisBrandsContent = document.getElementById("kotis_brands_content");

  const allMenus = document.querySelectorAll(".swag_menu");

  const allContents = [
    kotisCatalogContent,
    kotisPicksContent,
    kotisCustomContent,
    kotisGuidesContent,
    kotisBrandsContent
  ];

  if (!swagParent) return;

  function hideAllPanels() {
    allContents.forEach(panel => {
      if (panel) panel.style.display = "none";
    });

    allMenus.forEach(menu => {
      menu.classList.remove("force-active");
    });
  }

  function showPanel(content, menu) {
    hideAllPanels();

    if (content) content.style.display = "block";
    if (menu) menu.classList.add("force-active");
  }

  // Default panel when opening Swag
  swagParent.addEventListener("mouseenter", function () {

    setTimeout(function () {

      if (!swagParent.matches(":hover")) return;

      showPanel(kotisPicksContent, kotisPicksMenu);

    }, 80);

  });

  // Swag Catalog
  kotisCatalogMenu?.addEventListener("mouseenter", function () {
    showPanel(kotisCatalogContent, kotisCatalogMenu);
  });

  // Kotis Picks
  kotisPicksMenu?.addEventListener("mouseenter", function () {
    showPanel(kotisPicksContent, kotisPicksMenu);
  });

  // Kotis Custom
  kotisCustomMenu?.addEventListener("mouseenter", function () {
    showPanel(kotisCustomContent, kotisCustomMenu);
  });

  // Guides
  kotisGuidesMenu?.addEventListener("mouseenter", function () {
    showPanel(kotisGuidesContent, kotisGuidesMenu);
  });

  // Brands
  kotisBrandsMenu?.addEventListener("mouseenter", function () {
    showPanel(kotisBrandsContent, kotisBrandsMenu);
  });

  // Reset on leave
  swagParent.addEventListener("mouseleave", function () {
    allMenus.forEach(menu => {
      menu.classList.remove("force-active");
    });
  });

});

//END NEW
  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



(function () {
  function moveBrandNavigation() {
    const brandApp = document.querySelector(
      '#shopify-block-AU1hIRFhtYi9rSXM5U__easy_brand_page_brand_page_F37ixx'
    );

    const banner = document.querySelector(
      '#shopify-section-template--22763362418996__section_banner_with_svg_mcjyYN'
    );

    const navigation = brandApp?.querySelector('.ebp__header');
    const alphabet = brandApp?.querySelector('.ebp__az');

    if (!brandApp || !banner || !navigation || !alphabet) {
      return;
    }

    // Create a placeholder to preserve the original app layout.
    let placeholder = document.querySelector(
      '#brand-navigation-placeholder'
    );

    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.id = 'brand-navigation-placeholder';
      placeholder.style.display = 'none';

      navigation.parentNode.insertBefore(
        placeholder,
        navigation
      );
    }

    // Create a destination directly after the banner.
    let destination = document.querySelector(
      '#moved-brand-navigation'
    );

    if (!destination) {
      destination = document.createElement('div');
      destination.id = 'moved-brand-navigation';

      banner.insertAdjacentElement('afterend', destination);
    }

    // Move only the heading/search and alphabet navigation.
    destination.appendChild(navigation);
    destination.appendChild(alphabet);
  }

  function init() {
    moveBrandNavigation();

    let attempts = 0;

    const interval = setInterval(function () {
      moveBrandNavigation();
      attempts++;

      if (attempts >= 20) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
